module.exports = __webpack_public_path__ + "static/img/certificate3.a68a9ee3.png";